import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-forced-connections',
  	templateUrl: './toolcards-forced-connections.component.html',
  	styleUrls: ['./toolcards-forced-connections.component.scss']
})
export class ToolcardsForcedConnectionsComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
